import React, { Component } from 'react'
import { Divider, Button, Header, Input } from 'semantic-ui-react'
import * as moment from 'moment';
import axios from 'axios'
import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import { GetTimeAgo } from '../DashboardParts';
import { serverIp } from '../../../../config/constants';



export default class DateRequired extends Component {
    constructor(props) {
        super(props);

        this.state = {
            date: '',
            urgentReason: ''
        }
    }

    // dateSelectOnChange = (date) => {
    //     console.log("++++++++:dateSelectOnChange");
    //     console.log("date:" + date);
    //     this.props.urgentOrderDateSelect(date);
    // }

    dateSelectOnChange = (date) => {
        console.log("+++++++:dateSelectOnChange");
        console.log("date sent:" + date)
        this.setState({
            dateRequired: date,
        })

        this.setRequiredDate(date)
    }


    setRequiredDate = (date) => {
        console.log("mxu1 +++++ - makeOrderUrgent");
        console.log("+++: urgent:urgentDate," + date);

        var d = new Date();
        let now = moment().format('MMMM Do, h:mm:ss a');

        // let dateRequiredTemp = {
        //     dateRequired: true,
        //     dateRequiredBy: this.props.user.email,
        //     dateRequiredMilliseconds:date.valueOf(),
        //     timeDateRequiredSet: d.getTime(),
        //     dateRequiredSet: now,
        //     dateRequiredDateString: date.format('dddd MMMM Do'),
        // }

        let orderUpdates = {
            dateRequired: true,
            lastUpdate: now,
            dateRequiredBy: this.props.user.email,
            dateRequiredMilliseconds:date.valueOf(),
            timeDateRequiredSet: d.getTime(),
            dateRequiredSet: now,
            dateRequiredDateString: date.format('dddd MMMM Do'),
        }

        FbUtils.updateOrder(this.props.orderId, orderUpdates);
        this.sendUpdateToApi(date);
    }

    sendUpdateToApi(date) {
        axios.post(serverIp + 'orders/setDateRequired', {
            apiKey: 'asfsdfs@da7',
            fbOrderKey:this.props.orderId,
            adminEmail: this.props.user.email,
            dateRequired: date.valueOf()
        })
            .then((response) => {
                console.log(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }


    render() {

        
        const urgentDatePicker = this.props.admin && !this.props.order.urgent
            ? <SingleDatePicker
                date={this.state.dateRequired} // momentPropTypes.momentObj or null
                //onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                onDateChange={date => this.dateSelectOnChange(date)} // PropTypes.func.isRequired
                focused={this.state.focused} // PropTypes.bool
                onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
            />
            : ""

        // const showButton = this.props.admin && !this.props.order.urgent && this.props.urgentDate != ''
        const showButton = this.props.admin && !this.props.order.urgent && this.props.urgentDate != ''
            ? <div>
                <Input name='urgentReason' onChange={this.props.handleTextInputChange} placeholder='Reason for urgency' />
                <Button onClick={this.props.makeOrderUrgent} type='button' color='red' fluid size='large'>MAKE ORDER URGENT</Button>
            </div>
            : ""

        /**
         * SHOW URGENT DATE REQUIRED
         */
        const urgentDateConst = this.props.urgent
            ? <Header size='tiny' color='red'>DATE REQ:{this.props.order.urgentObject.urgentRequiredDateString}</Header>
            : ""

        const showRemoveUrgency = this.props.admin && this.props.order.urgent
            ? <div>

                <Button onClick={this.props.removeUrgency} type='button' color='orange' fluid size='large'>REMOVE URGENCY</Button>
                {urgentDateConst}
            </div>
            : ""

        const requiredDateUi = this.props.order.dateRequired 
            ?<div>
                <Header color='red' size='medium'>{'>>>'} {this.props.order.dateRequiredDateString}{'<<<<'}</Header>
                <GetTimeAgo dateNum={this.props.order.dateRequiredMilliseconds} />
             </div>
            :""

            
        return (
            <div>
                <Divider horizontal>{'DATE REQIUIRED'}</Divider>
                {requiredDateUi}
                <SingleDatePicker
                    date={this.state.date} // momentPropTypes.momentObj or null
                    //onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                    onDateChange={date => this.dateSelectOnChange(date)} // PropTypes.func.isRequired
                    focused={this.state.focused} // PropTypes.bool
                    onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                />
                {showButton}
                {showRemoveUrgency}
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/DateRequired/DateRequired.js